import styled from "@emotion/styled";
import colors from "styles/colors";
export const StyledMenuContentComponent = styled.div`
  box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.2);
  border: 1px solid ${colors["light-grey"]};
  background-color: ${colors["white"]};
  padding: 16px;
`;
